import { useLocation } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  if (pathSegments.length === 0) return null;

  const breadcrumbs = [{ name: "首页", href: "/" }];

  if (pathSegments[0] === "category" && pathSegments[1]) {
    const cat = categories.find((c) => c.slug === pathSegments[1]);
    breadcrumbs.push({ name: cat ? cat.name : "分类", href: location.pathname });
  } else if (pathSegments[0] === "article") {
    breadcrumbs.push({ name: "影视详情", href: location.pathname });
  } else if (pathSegments[0] === "about") {
    breadcrumbs.push({ name: "关于我们", href: "/about" });
  }

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-100/80 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center gap-2 text-sm text-foreground-600 flex-wrap">
          {breadcrumbs.map((crumb, index) => (
            <li key={crumb.href} className="flex items-center gap-2">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              )}
              {index === breadcrumbs.length - 1 ? (
                <span className="text-foreground-900 font-medium">{crumb.name}</span>
              ) : (
                <a href={crumb.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                  {crumb.name}
                </a>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}